import { lazy } from 'react'

/**
 * Kodeopdelte sider.
 *
 * Samlet her, så `router.tsx` kun indeholder rutetræet — og så hverken fil
 * blander komponenteksport med almindelig eksport, hvilket ville slå Vites
 * fast refresh fra.
 */

// --- Adgang ------------------------------------------------------------------

export const LoginPage = lazy(() =>
  import('@/features/auth/pages/LoginPage').then((m) => ({ default: m.LoginPage })),
)

export const RegisterPage = lazy(() =>
  import('@/features/auth/pages/RegisterPage').then((m) => ({ default: m.RegisterPage })),
)

export const ForgotPasswordPage = lazy(() =>
  import('@/features/auth/pages/PasswordPages').then((m) => ({ default: m.ForgotPasswordPage })),
)

export const ResetPasswordPage = lazy(() =>
  import('@/features/auth/pages/PasswordPages').then((m) => ({ default: m.ResetPasswordPage })),
)

export const ConfirmEmailPage = lazy(() =>
  import('@/features/auth/pages/ConfirmEmailPage').then((m) => ({ default: m.ConfirmEmailPage })),
)

export const AcceptInvitationPage = lazy(() =>
  import('@/features/auth/pages/AcceptInvitationPage').then((m) => ({
    default: m.AcceptInvitationPage,
  })),
)

/** Delelink udefra. Ligger uden for det beskyttede rutetræ — modtageren har ingen konto. */
export const SharedDocumentPage = lazy(() =>
  import('@/features/documents/pages/SharedDocumentPage').then((m) => ({
    default: m.SharedDocumentPage,
  })),
)

// --- Onboarding --------------------------------------------------------------

export const CreateOrganizationPage = lazy(() =>
  import('@/features/onboarding/pages/CreateOrganizationPage').then((m) => ({
    default: m.CreateOrganizationPage,
  })),
)

// --- App ---------------------------------------------------------------------

export const DashboardPage = lazy(() =>
  import('@/features/dashboard/pages/DashboardPage').then((m) => ({ default: m.DashboardPage })),
)

export const ProjectsPage = lazy(() =>
  import('@/features/projects/pages/ProjectsPage').then((m) => ({ default: m.ProjectsPage })),
)

export const CreateProjectPage = lazy(() =>
  import('@/features/projects/pages/CreateProjectPage').then((m) => ({
    default: m.CreateProjectPage,
  })),
)

export const ProjectDetailPage = lazy(() =>
  import('@/features/projects/pages/ProjectDetailPage').then((m) => ({
    default: m.ProjectDetailPage,
  })),
)

export const MyApprovalsPage = lazy(() =>
  import('@/features/documents/pages/MyApprovalsPage').then((m) => ({
    default: m.MyApprovalsPage,
  })),
)

// --- På tværs af projekter ----------------------------------------------------
// Egne chunks, som resten. Siderne henter hver sit moduls dialoger med, og de
// er store nok til at det ville kunne mærkes, hvis de fulgte med ved login.

export const DocumentsPage = lazy(() =>
  import('@/features/documents/pages/DocumentsPage').then((m) => ({ default: m.DocumentsPage })),
)

export const DrawingsPage = lazy(() =>
  import('@/features/drawings/pages/DrawingsPage').then((m) => ({ default: m.DrawingsPage })),
)

export const TendersPage = lazy(() =>
  import('@/features/tenders/pages/TendersPage').then((m) => ({ default: m.TendersPage })),
)

export const TasksPage = lazy(() =>
  import('@/features/tasks/pages/TasksPage').then((m) => ({ default: m.TasksPage })),
)

export const QualityPage = lazy(() =>
  import('@/features/quality/pages/QualityPage').then((m) => ({ default: m.QualityPage })),
)

export const CommunicationPage = lazy(() =>
  import('@/features/comments/pages/CommunicationPage').then((m) => ({
    default: m.CommunicationPage,
  })),
)

export const SustainabilityPage = lazy(() =>
  import('@/features/sustainability/pages/SustainabilityPage').then((m) => ({
    default: m.SustainabilityPage,
  })),
)

export const OperationsPage = lazy(() =>
  import('@/features/operations/pages/OperationsPage').then((m) => ({ default: m.OperationsPage })),
)

export const ReportsPage = lazy(() =>
  import('@/features/reports/pages/ReportsPage').then((m) => ({ default: m.ReportsPage })),
)

export const ReportDetailPage = lazy(() =>
  import('@/features/reports/pages/ReportDetailPage').then((m) => ({
    default: m.ReportDetailPage,
  })),
)

export const ProfileSettingsPage = lazy(() =>
  import('@/features/users/pages/ProfileSettingsPage').then((m) => ({
    default: m.ProfileSettingsPage,
  })),
)

export const SecuritySettingsPage = lazy(() =>
  import('@/features/users/pages/SecuritySettingsPage').then((m) => ({
    default: m.SecuritySettingsPage,
  })),
)

export const OrganizationSettingsPage = lazy(() =>
  import('@/features/organizations/pages/OrganizationSettingsPage').then((m) => ({
    default: m.OrganizationSettingsPage,
  })),
)

export const NotificationSettingsPage = lazy(() =>
  import('@/features/notifications/pages/NotificationSettingsPage').then((m) => ({
    default: m.NotificationSettingsPage,
  })),
)

export const ModulesPage = lazy(() =>
  import('@/features/organizations/pages/ModulesPage').then((m) => ({ default: m.ModulesPage })),
)

export const MembersPage = lazy(() =>
  import('@/features/organizations/pages/MembersPage').then((m) => ({ default: m.MembersPage })),
)

// --- Platformadministration ---------------------------------------------------
// Egne chunks: siderne hentes kun af de ganske få brugere, der har adgang til
// dem, og skal ikke ligge i den bundt, alle andre henter ved login.

export const PlatformOverviewPage = lazy(() =>
  import('@/features/platform/pages/PlatformOverviewPage').then((m) => ({
    default: m.PlatformOverviewPage,
  })),
)

export const PlatformCustomersPage = lazy(() =>
  import('@/features/platform/pages/PlatformCustomersPage').then((m) => ({
    default: m.PlatformCustomersPage,
  })),
)

export const PlatformCustomerPage = lazy(() =>
  import('@/features/platform/pages/PlatformCustomerPage').then((m) => ({
    default: m.PlatformCustomerPage,
  })),
)

export const PlatformUsersPage = lazy(() =>
  import('@/features/platform/pages/PlatformUsersPage').then((m) => ({
    default: m.PlatformUsersPage,
  })),
)

/** Hjælpecentret. Ligger i sin egen chunk — figurerne og deres CSS hentes først,
 *  når nogen faktisk slår noget op. */
export const HelpPage = lazy(() =>
  import('@/features/help/pages/HelpPage').then((m) => ({ default: m.HelpPage })),
)
